import React from "react";
import { styled } from "@linaria/react";
import classNames from "classnames";
import type { UserProfil } from "../../../api/useUsers";
import { easingBounce, easingBounceMs } from "@ui";
import { useUser } from "../../../api/useUser";
import { canUserDoOnProject } from "diagnostics-domain/canUserDo";
interface P {
  userProfil: UserProfil;
  userRowsExpanded: { [key: string]: boolean };
}

const StyledExpandArrow = styled.div`
  margin-right: 16px;
  margin-left: 6px;
  :after {
    cursor: pointer;
    display: block;
    content: "";
    width: 0.55em;
    height: 0.55em;
    border-width: 0 1px 1px 0;
    border-style: solid;
    transition: transform ${easingBounceMs}ms ${easingBounce};
    transform-origin: 60% 60%;
  }
  &:not(.opened):after {
    transform: rotate(-45deg);
  }
  &.opened:after {
    transform: rotate(45deg);
  }
  &.disabled {
    opacity: 0;
    pointer-events: none;
  }
`;

const ExpandArrow = ({ userProfil, userRowsExpanded }: P) => {
  const loggedInUser = useUser();
  const editableUserProjects = userProfil.roles.projects.filter(project =>
    canUserDoOnProject(loggedInUser, "PROJECT_READ", project.projectId),
  );
  const userLogin = userProfil.login;
  const isDisabled = userProfil.roles.global === "ADMIN" || editableUserProjects.length === 0;

  return (
    <StyledExpandArrow
      className={classNames({
        disabled: isDisabled,
        opened: userRowsExpanded[userLogin],
      })}
    />
  );
};
export default ExpandArrow;
